import Vue from 'vue';
import App from './App';
// import 'amfe-flexible/index.js'
import {router} from './router';
// import HTTP from './apis';
import * as utils from './utils';
// import Vant from 'vant'
// import 'vant/lib/index.css'
import VueCompositionApi from '@vue/composition-api'
// import wx from 'weixin-sdk-js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// Vue.prototype.$wx = wx;

// Vue.prototype.$HTTP = HTTP;
Vue.prototype.$utils = utils;
// Vue.use(Vant);
Vue.use(VueCompositionApi)
Vue.use(ElementUI);

new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
